import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AutomatedWithdrawals from '../views/AutomatedWithdrawals';
import { getAutomatedWithdrawalsRequest } from '../actions';
import {
  getAutomatedWithdrawalsFailedChecks,
  getAutomatedWithdrawalsPassedPercent,
} from '../selectors';
import {
  DASHBOARD_AUTOMATED_WITHDRAWALS_FORM,
  INITIAL_AUTOMATED_WITHDRAWALS_FILTERS_VALUES,
} from '../constants';
import { createPendingSelector } from 'modules/api/selectors';
import { hasOnlyEmptyValues } from 'utils/hasOnlyEmptyValues';
import NoDataAvailable from 'modules/common/NoDataAvailable';
import TPLoader from 'components/TP-UI/TPLoader';

const AutomatedWithdrawalsContainer = () => {
  const dispatch = useDispatch();
  const pending = useSelector(createPendingSelector(getAutomatedWithdrawalsRequest));
  const [filterApplied, setFilterApplied] = useState(
    !hasOnlyEmptyValues(INITIAL_AUTOMATED_WITHDRAWALS_FILTERS_VALUES),
  );
  const failedChecks = useSelector(getAutomatedWithdrawalsFailedChecks);
  const approvalStats = useSelector(getAutomatedWithdrawalsPassedPercent);

  useEffect(() => {
    dispatch(
      getAutomatedWithdrawalsRequest({
        ...INITIAL_AUTOMATED_WITHDRAWALS_FILTERS_VALUES,
        type: 'failedChecks',
      }),
    );
    dispatch(
      getAutomatedWithdrawalsRequest({
        ...INITIAL_AUTOMATED_WITHDRAWALS_FILTERS_VALUES,
        type: 'passedPercent',
      }),
    );
  }, [dispatch]);

  const handleChange = useCallback(
    (data) => {
      setFilterApplied(!hasOnlyEmptyValues(data));
      dispatch(
        getAutomatedWithdrawalsRequest({
          ...data,
          type: 'failedChecks',
        }),
      );
      dispatch(
        getAutomatedWithdrawalsRequest({
          ...data,
          type: 'passedPercent',
        }),
      );
    },
    [dispatch],
  );

  return !failedChecks ? (
    <TPLoader />
  ) : failedChecks.length === 0 && !filterApplied && !pending ? (
    <NoDataAvailable />
  ) : (
    <AutomatedWithdrawals
      loading={pending}
      failedChecks={failedChecks}
      approvalStats={approvalStats}
      form={DASHBOARD_AUTOMATED_WITHDRAWALS_FORM}
      onChange={handleChange}
    />
  );
};

export default AutomatedWithdrawalsContainer;
